import { gql } from "@apollo/client";

export const UpdateServiceReminder = gql`
    mutation UpdateServiceReminder ($id: ID!, $input: ServiceReminderUpdateInput!) {
        updateServiceReminder (id: $id, input: $input) {
            id
            nextDueDate
            lastServiceDate
        }
    }
`;
